import { DataBean } from "../DataBean";


export class FormTypeDinamic extends DataBean {

    public async getFormType(idFormType: number): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.FormType_getFormType_Number", [idFormType]);
    }

    public async getFormTypeCatalogPorPropiedadesLike(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService("Forms", "java.util.List_getFormTypeCatalogPorPropiedadesLike_java.util.Map_Number", [properties, maxRows]);
    }


    public async deleteFormType(idformtype: number): Promise<any> {
        return this.getCustomService("Forms", "boolean_deleteFormType_Number", [idformtype]);
    }

    public async updateFormType(bean: any): Promise<any> {
        return this.getCustomService("Forms", "com.advantage.forms.bean.FormType_updateFormType_com.advantage.forms.bean.FormType", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.advantage.forms.bean.FormType"
            }
        ]);
    }

}
